module.exports = __webpack_public_path__ + "static/img/icon_2.46c8a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_2.png
// module id = maCX
// module chunks = 0